(ns frontend.ui.component.lp-portal.tabbed-card.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn title-line
  []
  {:display        "flex"
   :flex-direction "row"
   :overflow       :hidden
   :margin-top     "16px"
   :border-bottom  (space-join ["1px solid" (theme/color [:tab-layout :title-line :border])])})

(defn title
  [selected?]
  (if selected?
    {:padding        "4px 0"
     :margin         "0 16px"
     :line-height    "1.5"
     :cursor         "pointer"
     :font-weight    "bold"
     :text-transform "uppercase"
     :color          (theme/color [:tab-layout :tab-title :text :selected])
     :letter-spacing "2.2px"
     :font-size      "14px"
     :border-bottom  (space-join ["2px solid"
                                  (theme/color [:tab-layout :tab-title :border :selected])])}
    {:cursor         "pointer"
     :padding        "4px 0"
     :line-height    "1.5"
     :margin         "0 16px"
     :font-weight    "bold"
     :text-transform "uppercase"
     :color          (theme/color [:tab-layout :tab-title :text :default])
     :font-size      "14px"
     :letter-spacing "2.2px"
     :border-bottom  (space-join ["2px solid"
                                  (theme/color [:tab-layout :tab-title :border :default])])}))

(defn card
  []
  {:padding-top "16"})

(defn default-padding
  []
  {:padding-top "16px"})
